"use client"
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import { EffectCoverflow, Autoplay, Pagination } from 'swiper/modules';
import Image from 'next/image';
import { Button } from '@/components';

const ProductGallery = ({ images }: any) => {


    return (
        <div className="w-full relative p-4 overflow-hidden">
            
            <Swiper
                effect={'coverflow'}
                grabCursor={true}
                centeredSlides={true}
                slidesPerView={'auto'}
                coverflowEffect={{
                    rotate: 30,
                    stretch: 0,
                    depth: 200,
                    modifier: 1,
                    slideShadows: true,
                }}
                pagination={{
                    el: ".swiper-pagination",
                    type: "bullets",
                    bulletActiveClass: 'swiper-pagination-bullet-active',
                    // bulletElement: '',
                    clickable: true,

                }}
                loop={true}
                autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true
                }}
                modules={[Autoplay, Pagination]}
                className="relative"
            >
                <div className='absolute z-10 -bottom-1 inset-x-0 mx-auto w-36 '>
                    <Image
                        src="/images/curvedblob.svg"
                        alt="Header Curve"
                        width={1000}
                        height={1000}
                        className="block"
                    />
                    <div className="swiper-pagination "></div>

                </div>
                {images.map((slide: any) => (
                    <SwiperSlide key={slide.id}>
                        <div
                            className="relative flex flex-col items-center justify-center shadow-xl overflow-hidden h-96"
                        >
                            <div className='bg-black absolute inset-0 w-full h-full'>
                                <Image src={slide.image} alt={`${slide.title} - ${slide.description}`} fill
                                    style={{ objectFit: 'cover' }}
                                    sizes="100" />
                            </div>
                            <div className="absolute inset-0 bg-black/40 "></div>

                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default ProductGallery;